import { useMemo } from 'react';
import { useGetAllAssignableUsersQuery } from 'services/api/user.api';

import type { FilterOption } from './types';

/**
 * Fetches assignable users for a business unit and returns them as FilterOption[].
 * Suitable for feeding into MasterFilter's dynamicOptions for userSelect fields.
 */
export function useAssignableUsers(businessUnitId: number | null, options?: { skip?: boolean }): FilterOption[] {
  const skip = options?.skip ?? false;
  const { data } = useGetAllAssignableUsersQuery(businessUnitId as number, {
    skip: skip || !businessUnitId || businessUnitId === -1,
  });

  return useMemo(
    () =>
      (data?.assignableUsers ?? []).map((u) => ({
        value: String(u.id),
        label: u.name ?? u.email,
      })),
    [data]
  );
}
